import DashboardComponent from "../components/dashboard/dashboard.component";


const Dashboard = () => {

    return (
        <DashboardComponent></DashboardComponent>
    )

}

export default Dashboard;